 <!-- dr panel (start) -->
 <div class="drPanel">
    
        <i class="drPanel-icon icon-dr"></i>

        <div class="drPanel-info">
            <figure class="drPanel-image">
                <img src="assets/images/dr.jpg" alt=""/>
            </figure>
            <div class="drPanel-desc">
                <div class="drPanel-name">
                    {{loginService.getUserName()}}
                </div>
                <div class="drPanel-detail">
                    {{loginService.Clinic ? loginService.Clinic : ''}}
                </div>
            </div>
        </div>

        <div class="drPanel-controls">
            <a class="drPanel-controls-item drPanel-controls-icon-gear" style='cursor: pointer;' [matMenuTriggerFor]="menu">
                Settings
            </a>
            <mat-menu #menu="matMenu">
                <a mat-menu-item (click)="goDefaults()" routerLink="/defaults">Defaults</a>
                <a mat-menu-item routerLink="/Custom" *ngIf="!loginService.isCardio && ! loginService.isGastro && false">Custom Header</a>
                <a mat-menu-item routerLink="/Stats" *ngIf="loginService.hasPremission('Stats') || loginService.isAdmin">Stats</a>
                <a mat-menu-item (click)="redirectAdministration('questionnaires')" *ngIf="loginService.hasPremission('Questionnaires')">Questionnaires</a>
                <a mat-menu-item (click)="showLimits = true" *ngIf="loginService.isAdmin && loginService.hasPremission('Limits')">Limits</a>
                <a mat-menu-item (click)="showLogin = true" *ngIf="loginService.ishospital && loginService.isAdmin">Export Data</a>
                <a mat-menu-item routerLink="/Searchdata" *ngIf="loginService.ishospital && loginService.isAdmin">Search By Text</a>
                <a mat-menu-item>Language</a>
                <a mat-menu-item>Measurements</a>
                <a mat-menu-item (click)="openAbout()">About</a>
            </mat-menu>
            <a (click)="logout()" class="drPanel-controls-item drPanel-controls-icon-logout" style='cursor: pointer;'>
                Logout
            </a>
        </div>
    <app-loginbox *ngIf="showLogin" (closed)="showLogin=false;" [isExport]="true"></app-loginbox>
    <app-limits *ngIf="showLimits" (closed)="showLimits=false;"></app-limits>
    <ng-template #aboutTpl>
    <div class="t-popup popup-patientDetails popup-patientDetails--about">
        <div class="t-popup-close"></div>
        <div class="t-popup-frame">
            <div class="t-popup-body">
                Artisan Sonics Ltd. Cardio application version: {{ currentApplicationVersion }}<br />
                Released: {{ currentAppDate }}<br />
                Using API version: {{ loginService.APIversion }}
                <br />
                <br />
                <a class="search-btn" target="_blank" href="../../assets/CHANGELOG.md">View Changelog</a>
                <button class="t-btn-popup-close" aria-label="close popup" (click)="closeAbout()"></button>
            </div>
        </div>
    </div>
    </ng-template>

</div>
    <!-- dr panel (end) -->
